export const text = {
  MyDevelopment: "Mijn ontwikkeling",
  AssignGoalToTeamaddedsuccessfully:
    "Doel aan team toewijzen succesvol toegevoegd",
  AssignGoalToTeamupdatedsuccessfully:
    "Doel aan team toewijzen succesvol bijgewerkt",
  AssignGoalToTeamDeletedsuccessfully:
    "Doel aan team toewijzen succesvol verwijderd",
  Blogaddedsuccessfully: "Blog succesvol toegevoegd",
  Blogupdatedsuccessfully: "Blog succesvol bijgewerkt",
  BlogDeletedsuccessfully: "Blog succesvol verwijderd",
  MyDevelopmentGoaladdedsuccessfully:
    "Mijn ontwikkelingsdoel succesvol toegevoegd",
  MyDevelopmentGoalupdatedsuccessfully:
    "Mijn ontwikkelingsdoel succesvol bijgewerkt",
  MyDevelopmentGoalDeletedsuccessfully:
    "Mijn ontwikkelingsdoel succesvol verwijderd",
  GoalTitle: "Doeltitel",
  StartDate: "Startdatum",
  EndDate: "Einddatum",
  SubTitle: "Subtitel",
  Author: "Auteur",
  AddMyDevelopmentGoal: "Mijn ontwikkelingsdoel toevoegen",
  AddAssignGoalToTeam: "Doel aan team toewijzen",
  AddMyDevelopmentBlog: "Mijn ontwikkelingsblog toevoegen",
  AddMyDevelopmentForm: "Mijn ontwikkelingsformulier toevoegen",
  MyDevelopmentGoal: "Mijn ontwikkeling doelen",
  AssignGoalToTeam: "Doel aan team toewijzen",
  MyDevelopmentBlog: "Mijn ontwikkeling blog",
  MyDevelopmentForm: "Mijn ontwikkeling formulieren",
};
